<template>
    <div class="search row mb-5">
        <search-bar v-model="searchString"
                    placeholder="Suchen"></search-bar>
        <div v-for="element in filteredList" class="search__element col-12 mb-3 pb-3 border-bottom ">
            <slot :element="element" name="element-slot"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchableList',
    props: {
        elements: {},
    },

    data() {
        return {
            elementItem: this.elements,
            searchString: null,
        };
    },
    computed: {
        filteredList() {
            if (!this.searchString) {
                return this.elementItem;
            }
            return this.elementItem.filter(element => {
                return element.data.name.toLowerCase().includes(this.searchString.toLowerCase());
            });
        },
    },

    watch: {
        searchString(newValue) {
            this.searchString = newValue;
        },
    },
};
</script>
